/**
 * Status tag component for OPL issues.
 */

import { Tag } from 'antd';
import type { IssueStatus } from '@/types';

const STATUS_CONFIG: Record<IssueStatus, { color: string; label: string }> = {
  opened: { color: 'green', label: '开放' },
  closed: { color: 'default', label: '已关闭' },
};

interface IssueStatusTagProps {
  status: IssueStatus;
}

const IssueStatusTag: React.FC<IssueStatusTagProps> = ({ status }) => {
  const config = STATUS_CONFIG[status] || { color: 'default', label: status };
  return <Tag color={config.color}>{config.label}</Tag>;
};

export default IssueStatusTag;
